<template>
  <div class="d-flex">
    <v-tooltip
      v-if="type === gettingFilesBtnsTypes.PRINT || type === gettingFilesBtnsTypes.PRINT_AND_DOWNLOAD"
      bottom
    >
      <template v-slot:activator="{ on, attrs }">
        <template v-if="fileType === gettingRequestTypes.IMAGE">
          <v-btn
            v-if="fileId !== null"
            v-bind="attrs"
            v-on="on"
            icon
            color="accent darken-4"
            @click="getFile(gettingFileTypes.PRINT)"
            :loading="loading.print"
            :disabled="gettingFileError"
          >
            <v-icon>mdi-image</v-icon>
          </v-btn>

          <v-btn
            v-else
            v-bind="attrs"
            v-on="on"
            icon
            color="accent darken-4"
            disabled
          >
            <v-icon>mdi-image-off-outline</v-icon>
          </v-btn>
        </template>

        <template v-else>
          <v-btn
            v-bind="attrs"
            v-on="on"
            icon
            color="#000"
            @click="getFile(gettingFileTypes.PRINT)"
            :loading="loading.print"
            :disabled="gettingFileError"
          >
            <v-icon>mdi-printer-outline</v-icon>
          </v-btn>
        </template>
      </template>

      <span v-if="fileType === gettingRequestTypes.IMAGE">Открыть</span>

      <span v-else>Печать</span>
    </v-tooltip>

    <v-tooltip
      v-if="type === gettingFilesBtnsTypes.DOWNLOAD || type === gettingFilesBtnsTypes.PRINT_AND_DOWNLOAD"
      bottom
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          v-bind="attrs"
          v-on="on"
          icon
          text
          color="#000"
          @click="getFile(gettingFileTypes.DOWNLOAD)"
          :loading="loading.download"
          :disabled="gettingFileError"
        >
          <v-icon>
            mdi-tray-arrow-down
          </v-icon>
        </v-btn>
      </template>
      <span>Скачать</span>
    </v-tooltip>
  </div>
</template>

<script lang="ts">
import { Component, Mixins, Prop } from 'vue-property-decorator';
import { GettingFile } from '@/enums';
import GettingFileMixin from '@/mixins/getting-file';

@Component
export default class GettingFilesBtns extends Mixins(GettingFileMixin) {
  @Prop({ type: String, default: GettingFile.BtnsTypes.DOWNLOAD })
  type!: GettingFile.BtnsTypes;

  @Prop({ type: Number, default: null })
  fileId!: number;

  @Prop({ type: String, default: 'Файл.txt' })
  fileName!: string;

  @Prop({ type: String, default: GettingFile.RequestTypes.DOCUMENT })
  fileType!: string;

  @Prop({ type: String, default: null })
  slug!: GettingFile.Slugs;

  gettingFilesBtnsTypes = GettingFile.BtnsTypes;
  gettingFileTypes = GettingFile.Types;
  gettingRequestTypes = GettingFile.RequestTypes;
  loading: Record<string, boolean> = {
    download: false,
    print: false,
  };

  getFile(type: GettingFile.Types) {
    if (this.gettingFileError || this.loading[type]) {
      return;
    }

    this.loading[type] = true;

    if (this.file !== null) {
      const success = this.doFile(this.file, type, this.fileName);

      this.loading[type] = false;
      this.gettingFileError = !success;
    } else {
      const params: Record<string, string | number> = {};

      if (this.fileId !== null) {
        params.id = this.fileId;
      }

      if (this.slug !== null) {
        params.slug = this.slug;
      }

      params.file_type = this.fileType;

      this.requestFile(params)
        .then(() => {
          const success = this.doFile(this.file, type, this.fileName);

          this.loading[type] = false;

          if (success) {
            this.$emit('got', true);
          } else {
            this.gettingFileError = true;
          }
        });
    }
  }
}
</script>
